"use client";

import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { fetchVideos } from "@/lib/actions/videos/fetchRandomVideos";
import { Item } from "@radix-ui/react-accordion";

const VideoCard = () => {
  const [videos, setVideos] = useState<any[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const getData = async () => {
      const data = await fetchVideos(1); // Fetch more videos to make the feed more seamless
      if (data?.length) setVideos(data);
    };
    getData();
  }, []);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    touchEndY.current = e.changedTouches[0].clientY;
    const swipeDistance = touchStartY.current - touchEndY.current;

    if (swipeDistance > 50) {
      // Swipe up (next video)
      setDirection(1);
      setActiveIndex((prevIndex) => (prevIndex + 1) % videos.length);
    } else if (swipeDistance < -50) {
      // Swipe down (previous video)
      setDirection(-1);
      setActiveIndex(
        (prevIndex) => (prevIndex - 1 + videos.length) % videos.length
      );
    }
  };

  const handleVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  console.log("Active video: ");

  return (
    <div className="flex flex-col items-center justify-center h-screen overflow-hidden bg-black">
      <div
        className="relative w-full h-full flex items-center justify-center overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {videos.length > 0 ? (
          <AnimatePresence mode="sync">
            <motion.video
              ref={videoRef}
              key={activeIndex}
              playsInline
              src={videos[activeIndex]?.video}
              autoPlay
              loop
              className="absolute h-full w-auto max-w-full object-cover"
              onClick={handleVideoClick}
              initial={{ y: `${direction * 100}%`, opacity: 0.9 }}
              animate={{ y: "0%", opacity: 1 }}
              exit={{ y: `${-direction * 100}%`, opacity: 0.9 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            />
          </AnimatePresence>
        ) : (
          <p className="text-white">Loading videos...</p>
        )}
      </div>
      <div className="absolute bottom-16 left-0">
        <div className="flex flex-col gap-2 p-4 px-2 text-zinc-50 ">
          <h2>{videos[activeIndex]?.title}</h2>
          <h2>{videos[activeIndex]?.description}</h2>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
